'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mapProps = require('recompose/mapProps');

var _mapProps2 = _interopRequireDefault(_mapProps);

var _setWrappedDisplayName = require('./setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var enhancer = function enhancer(propName) {
  return (0, _mapProps2.default)(function (props) {
    return _extends({}, props[propName] || {}, props);
  });
};

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'flattenDefaultProp', true);


//////////////////
// WEBPACK FOOTER
// ./~/coact-utils/flattenDefaultProp.js
// module id = 1630
// module chunks = 0